$(function () {
  function closeLoginWindow() {
    $("body, html").removeClass("user-action-visible login-window-visible");
    $("#login").attr("aria-hidden", "true");
  }

  function isLoginVisible() {
    return $("body").hasClass("user-action-visible") || $("html").hasClass("user-action-visible");
  }

  /**
   * Zabrání zavření při vyjetí myší z popupu.
   * Pokud máš někde starší mouseleave handler, tohle ho přebije v capture fázi.
   */
  document.addEventListener(
    "mouseleave",
    function (event) {
      const login = document.querySelector("#login");

      if (!login) return;

      if (login.contains(event.target)) {
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  /**
   * Klik uvnitř login okna nesmí probublat na document,
   * jinak by se zavřelo jako klik vedle.
   */
  $(document).on("click", "#login .popup-widget-inner", function (event) {
    event.stopPropagation();
  });

  /**
   * Zavření přes křížek.
   */
  $(document).on("click", "#login .close", function (event) {
    event.preventDefault();
    event.stopPropagation();

    closeLoginWindow();
  });

  /**
   * Zavření klikem mimo login okno.
   */
  $(document).on("click", function (event) {
    if (!isLoginVisible()) return;

    const $target = $(event.target);

    if ($target.closest("#login .popup-widget-inner").length || $target.closest(".login-widget").length || $target.closest(".customLoginPopup").length) {
      return;
    }

    closeLoginWindow();
  });
});
